import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/forgot-password/`,
        { email }
      );
      setSuccess(response.data.message);
      setTimeout(() => navigate("/reset_password"), 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div
        className="card p-4 shadow-lg"
        style={{ width: "400px", borderRadius: "15px" }}
      >
        <div className="text-center">
          <i className="fas fa-key fa-3x text-info"></i>
          <h3 className="fw-bold mt-3">Forgot Password?</h3>
          <p className="text-muted">Enter your email to reset your password.</p>
        </div>
        {error && <div className="alert alert-danger mt-2">{error}</div>}
        {success && <div className="alert alert-success mt-2">{success}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Email Address</label>
            <div className="input-group">
              <span className="input-group-text bg-light border-dark">
                <i className="fas fa-envelope text-info"></i>
              </span>
              <input
                type="email"
                className="form-control border-dark shadow-sm"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="text-center">
            <button className="btn btn-info fw-bold shadow-sm" type="submit">
              Send OTP <i className="fas fa-paper-plane"></i>
            </button>
          </div>
        </form>
        <div className="text-center mt-3">
          <Link to="/login" className="text-info fw-semibold">
            <i className="fas fa-arrow-left"></i> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
